import { render, staticRenderFns } from "./Trajectory.vue?vue&type=template&id=2bd98311&scoped=true"
import script from "./Trajectory.vue?vue&type=script&lang=js"
export * from "./Trajectory.vue?vue&type=script&lang=js"
import style0 from "./Trajectory.vue?vue&type=style&index=0&id=2bd98311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd98311",
  null
  
)

export default component.exports